import React from "react"
import Layout from "components/structure-components/layout"
import { SEOComponent } from "components/seo-components"

import { Order } from "components/order-functions"

const UmweltbauBestellen = ({ location }) => {
  const breadcrumb_array = [
    {
      type: "BreadcrumbLink",
      content: `B_I umweltbau`,
      link: `/fachzeitschriften/umweltbau`,
      react_key: "footer_breadcrumb_item_1",
      ressort: "umweltbau",
    },
    {
      type: "BreadcrumbSpan",
      content: "Abo",
      link: ``,
      react_key: "footer_breadcrumb_item_4",
      ressort: "umweltbau",
    },
  ]
  return (
    <Layout {...{ location, breadcrumb_array }}>
      <SEOComponent
        title="B_I umweltbau bestellen"
        description="Hier können Sie die B_I umweltbau bestellen"
      />

      {/* pass product ID and Name to order component */}

      <Order
        productID="806ccba9-d40e-4c73-9d6c-01fe34a04d49"
        name="B_I umweltbau bestellen"
      />
    </Layout>
  )
}
export default UmweltbauBestellen
